import type { TFunction } from 'i18next';
import { DateTime } from 'luxon';
import { formatTime } from '~/lib/datetime';
import type { NetworkDeviceSignals__SignalSchedule as SignalSchedule } from '../queries/list.generated';

const WEEKDAYS = [
  { dow: 1, key: 'monday' },
  { dow: 2, key: 'tuesday' },
  { dow: 3, key: 'wednesday' },
  { dow: 4, key: 'thursday' },
  { dow: 5, key: 'friday' },
  { dow: 6, key: 'saturday' },
  { dow: 0, key: 'sunday' },
];

const formatDate = (iso: string) => DateTime.fromISO(iso, { zone: 'utc' }).toFormat('LLL d, yyyy');

export const getSignalScheduleDescription = (schedule: SignalSchedule, t: TFunction) => {
  const at = t('pages.device_signals.schedule_description.at', {
    time: formatTime(schedule.startTime),
  });

  if (schedule.frequency === 'ONCE') {
    const on = t('pages.device_signals.schedule_description.once', {
      date: formatDate(schedule.startsOn),
    });
    return on + at;
  }

  const until = schedule.endsOn
    ? t('pages.device_signals.schedule_description.until', { date: formatDate(schedule.endsOn) })
    : '';

  if (schedule.frequency === 'WEEKLY') {
    const days = WEEKDAYS.filter(({ dow }) => schedule.weekdays?.includes(dow))
      .map(({ key }) => t(`common.schedule_description.day_abbreviations.${key}`))
      .join(', ');
    return t('pages.device_signals.schedule_description.weekly', { days }) + at + until;
  }

  return t('pages.device_signals.schedule_description.daily') + at + until;
};
